import React, { createContext, useState, useEffect } from "react";
import AuthService from "./authservice";
import Loader from "./preloader";

export const AuthContext = createContext();

export default ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    AuthService.isAuthenticated()
      .then((data) => {
        setUser(data.user);
        setIsAuthenticated(data.isAuthenticated);
        setIsLoaded(true);
      })
      .catch((err) => {
        console.error("Auth check failed:", err);
        setIsLoaded(true);
      });

    const interval = setInterval(
      () => {
        if (!localStorage.getItem("SkeyegateAuthToken")) {
          clearInterval(interval);
          return;
        }
        AuthService.isAuthenticated()
          .then((data) => {
            setUser(data.user);
            setIsAuthenticated(data.isAuthenticated);
            setIsLoaded(true);
          })
          .catch((err) => {
            console.error("Auth check failed:", err);
            setIsLoaded(true);
          });
      },
      5 * 60 * 1000,
    );
    return () => clearInterval(interval);
  }, []);

  return !isLoaded ? (
    <Loader />
  ) : (
    <AuthContext.Provider
      value={{ user, setUser, isAuthenticated, setIsAuthenticated }}
    >
      {children}
    </AuthContext.Provider>
  );
};
